import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'semantic-ui-react';
import SnukForm from './SnukForm';

const EditModal = (props) => {
  const {
    title, isPending, validation, size, closeModalAction, updateItemAction, itemId,
    ...rest
  } = props;
  const { isError, message } = validation;

  return (
    <Modal open size={size}>
      <Modal.Header className="modal-header">
        {title}
      </Modal.Header>
      <Modal.Content>
        <SnukForm
          externalMessage={{ isError, messages: message.length > 1 ? [message] : [] }}
          isPending={isPending}
          itemId={itemId}
          onCancelAction={() => closeModalAction(itemId)}
          onSubmitAction={updateItemAction}
          {...rest}
        />
      </Modal.Content>
    </Modal>
  );
};

EditModal.propTypes = {
  closeModalAction: PropTypes.func.isRequired,
  updateItemAction: PropTypes.func.isRequired,
  validation: PropTypes.shape({
    isError: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
  shape: PropTypes.shape({}).isRequired,
  schema: PropTypes.shape({}).isRequired,
  isPending: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  size: PropTypes.string,
};

EditModal.defaultProps = {
  size: 'small',
};

export default EditModal;



// WEBPACK FOOTER //
// ./src/components/reusable/EditModal.js